import i18n from "../../lang/i18n";
// Layouts
import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";

//Program Pages
import ProgramCriterionList from "@/pages/Program/Criterion/Index.vue";
import ProgramCriterionCreateForm from "@/pages/Program/Criterion/CreateForm.vue";
import ProgramCriterionEditForm from "@/pages/Program/Criterion/EditForm.vue";
import ProgramCriterionCategoryList from "@/pages/Program/CriterionCategory/Index.vue";
import ProgramCriterionCategoryCreateForm from "@/pages/Program/CriterionCategory/CreateForm.vue";
import ProgramCriterionCategoryEditForm from "@/pages/Program/CriterionCategory/EditForm.vue";
import ProgramTemplateList from "@/pages/Program/ProgramTemplate/Index.vue";
import ProgramTemplateCriteria from "@/pages/Program/ProgramTemplate/ProgramTemplateCriteria.vue";
import ProgramList from "@/pages/Program/Index.vue";
import ProgramCreateForm from "@/pages/Program/CreateProgramPage.vue";
import ProgramEditForm from "@/pages/Program/EditProgramPage.vue";
import ManageProgramRatings from "@/pages/Program/ManageProgramRatings.vue";
import ProgramTypeList from "@/pages/Program/ProgramType/Index.vue";
import ProgramTypeCreateForm from "@/pages/Program/ProgramType/CreateForm.vue";
import ProgramTypeEditForm from "@/pages/Program/ProgramType/EditForm.vue";
import ProgramDivisionList from "@/pages/Program/ProgramDivision/Index.vue";
import ProgramDivisionCreateForm from "@/pages/Program/ProgramDivision/CreateForm.vue";
import ProgramDivisionEditForm from "@/pages/Program/ProgramDivision/EditForm.vue";
import ExportPdf from "@/pages/Program/ExportPdf/Index.vue";
import ExportCertificateCover from "@/pages/Program/ExportCertificateCover/Index.vue";

export const programPages = {
  path: "/program",
  component: DashboardLayout,
  children: [
    {
      path: "",
      name: "ProgramList",
      components: { default: ProgramList },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.program_list")
      }
    },
    {
      path: "add",
      name: "ProgramCreateForm",
      components: { default: ProgramCreateForm },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.program_create")
      }
    },
    {
      path: ":id/view",
      name: "ProgramEditForm",
      components: { default: ProgramEditForm },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.program_edit")
      }
    },
    {
      path: ":id/ratings",
      name: "ManageProgramRatings",
      components: { default: ManageProgramRatings },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.manage_program_score")
      }
    },
    {
      path: ":id/export-certificate",
      name: "ExportProgramPdf",
      components: { default: ExportPdf },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.export_certificate")
      }
    },
    {
      path: ":id/export-certificate-cover",
      name: "ExportProgramCertificateCover",
      components: { default: ExportCertificateCover },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.export_certificate_cover")
      }
    }
  ]
};

export const programTemplatePages = {
  path: "/program-template",
  component: DashboardLayout,
  children: [
    {
      path: "",
      name: "ProgramTemplateList",
      components: { default: ProgramTemplateList },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.program_template_list")
      }
    },
    {
      path: ":id/management-criteria",
      name: "ProgramTemplateCriteria",
      components: { default: ProgramTemplateCriteria },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.management_template_criteria")
      }
    }
  ]
};

export const programCriterionPages = {
  path: "/program-criterion",
  component: DashboardLayout,
  children: [
    {
      path: "",
      name: "ProgramCriterionList",
      components: { default: ProgramCriterionList },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.program_criterion_list")
      }
    },
    {
      path: "add",
      name: "ProgramCriterionCreateForm",
      components: { default: ProgramCriterionCreateForm },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.program_criterion_create")
      }
    },
    {
      path: ":id/view",
      name: "ProgramCriterionEditForm",
      components: { default: ProgramCriterionEditForm },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.program_criterion_edit")
      }
    }
  ]
};

export const programTypePages = {
  path: "/program-type",
  component: DashboardLayout,
  children: [
    {
      path: "",
      name: "ProgramTypeList",
      components: { default: ProgramTypeList },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.program_type_list")
      }
    },
    {
      path: "add",
      name: "ProgramTypeCreateForm",
      components: { default: ProgramTypeCreateForm },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.program_type_create")
      }
    },
    {
      path: ":id/view",
      name: "ProgramTypeEditForm",
      components: { default: ProgramTypeEditForm },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.program_type_edit")
      }
    }
  ]
};

export const programDivisionPages = {
  path: "/program-division",
  component: DashboardLayout,
  children: [
    {
      path: "",
      name: "ProgramDivisionList",
      components: { default: ProgramDivisionList },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.program_division_list")
      }
    },
    {
      path: "add",
      name: "ProgramDivisionCreateForm",
      components: { default: ProgramDivisionCreateForm },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.program_division_create")
      }
    },
    {
      path: ":id/view",
      name: "ProgramDivisionEditForm",
      components: { default: ProgramDivisionEditForm },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.program_division_edit")
      }
    }
  ]
};

export const programCriterionCategoryPages = {
  path: "/program-criterion-category",
  component: DashboardLayout,
  children: [
    {
      path: "",
      name: "ProgramCriterionCategoryList",
      components: { default: ProgramCriterionCategoryList },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.program_criterion_category_list")
      }
    },
    {
      path: "add",
      name: "ProgramCriterionCategoryCreateForm",
      components: { default: ProgramCriterionCategoryCreateForm },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.program_criterion_category_create")
      }
    },
    {
      path: ":id/view",
      name: "ProgramCriterionCategoryEditForm",
      components: { default: ProgramCriterionCategoryEditForm },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.program_criterion_category_edit")
      }
    }
  ]
};

export default {
  programPages,
  programTemplatePages,
  programCriterionPages,
  programCriterionCategoryPages,
  programDivisionPages,
  programTypePages
};
